var _mask, _path, _path2, _path3, _path4, _path5;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgVitalsfacescan(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 52,
    height: 52,
    viewBox: "0 0 52 52",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "path-1-inside-1_535_20813",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 12C0 5.37258 5.37258 0 12 0H40C46.6274 0 52 5.37258 52 12V40C52 46.6274 46.6274 52 40 52H12C5.37258 52 0 46.6274 0 40V12Z"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 12C0 5.37258 5.37258 0 12 0H40C46.6274 0 52 5.37258 52 12V40C52 46.6274 46.6274 52 40 52H12C5.37258 52 0 46.6274 0 40V12Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12 0V0.8H40V0V-0.8H12V0ZM52 12H51.2V40H52H52.8V12H52ZM40 52V51.2H12V52V52.8H40V52ZM0 40H0.8V12H0H-0.8V40H0ZM12 52V51.2C5.81441 51.2 0.8 46.1856 0.8 40H0H-0.8C-0.8 47.0692 4.93075 52.8 12 52.8V52ZM52 40H51.2C51.2 46.1856 46.1856 51.2 40 51.2V52V52.8C47.0692 52.8 52.8 47.0692 52.8 40H52ZM40 0V0.8C46.1856 0.8 51.2 5.81441 51.2 12H52H52.8C52.8 4.93076 47.0692 -0.8 40 -0.8V0ZM12 0V-0.8C4.93076 -0.8 -0.8 4.93075 -0.8 12H0H0.8C0.8 5.81441 5.81441 0.8 12 0.8V0Z",
    fill: "#004276",
    mask: "url(#path-1-inside-1_535_20813)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M15.5 20.1667V17.8333C15.5 17.2145 15.7458 16.621 16.1834 16.1834C16.621 15.7458 17.2145 15.5 17.8333 15.5H20.1667M31.8333 15.5H34.1667C34.7855 15.5 35.379 15.7458 35.8166 16.1834C36.2542 16.621 36.5 17.2145 36.5 17.8333V20.1667M36.5 31.8333V34.1667C36.5 34.7855 36.2542 35.379 35.8166 35.8166C35.379 36.2542 34.7855 36.5 34.1667 36.5H31.8333M20.1667 36.5H17.8333C17.2145 36.5 16.621 36.2542 16.1834 35.8166C15.7458 35.379 15.5 34.7855 15.5 34.1667V31.8333",
    strokeWidth: 2.21667,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#004276"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M30.0827 24.8333C30.0827 27.0885 28.2545 28.9167 25.9993 28.9167C23.7442 28.9167 21.916 27.0885 21.916 24.8333C21.916 22.5782 23.7442 20.75 25.9993 20.75C28.2545 20.75 30.0827 22.5782 30.0827 24.8333Z",
    strokeWidth: 2.21667,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#004276"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M21.334 32.9993C22.5007 31.366 24.134 30.666 26.0007 30.666C27.8673 30.666 29.5007 31.366 30.6673 32.9993",
    strokeWidth: 2.21667,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#004276"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVitalsfacescan);
export default __webpack_public_path__ + "static/media/vitals face scan.6a81f9a7f837f6e29823354758b0d292.svg";
export { ForwardRef as ReactComponent };